import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PatchTask } from '../../redux/taskSlice';
import { Menu, MenuTrigger, MenuPopover, MenuList } from '@fluentui/react-components';
import styles from './css/index.module.css';

const toDateInputValue = value => {
    if (!value) return '';
    // API may return ISO timestamps; <input type="date"> needs YYYY-MM-DD
    return String(value).split('T')[0];
};

const DeadlinePickerMenu = ({ task, onDeadlineSelect, onRequestDeadlineChange, children }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [deadline, setDeadline] = useState(toDateInputValue(task?.deadline));

    useEffect(() => {
        setDeadline(toDateInputValue(task?.deadline));
    }, [task?.id, task?.deadline]);

    const handleSaveDeadline = async () => {
        if (!task?.id) return;
        if (onRequestDeadlineChange) {
            onRequestDeadlineChange({ deadline: deadline || null });
            setOpen(false);
            return;
        }
        try {
            await dispatch(
                PatchTask({
                    body: {
                        deadline: deadline || null,
                    },
                    id: task.id,
                    suppressToast: true,
                }),
            );
            onDeadlineSelect && onDeadlineSelect({ deadline });
            setOpen(false);
        } catch (error) {
            console.error('Error updating task deadline:', error);
        }
    };

    const handleClearDeadline = async () => {
        if (!task?.id) return;
        if (onRequestDeadlineChange) {
            onRequestDeadlineChange({ deadline: null });
            setDeadline('');
            setOpen(false);
            return;
        }
        try {
            await dispatch(
                PatchTask({
                    body: {
                        deadline: null,
                    },
                    id: task.id,
                    suppressToast: true,
                }),
            );
            setDeadline('');
            onDeadlineSelect && onDeadlineSelect({ deadline: null });
            setOpen(false);
        } catch (error) {
            console.error('Error clearing task deadline:', error);
        }
    };

    return (
        <Menu open={open} onOpenChange={(e, data) => setOpen(data.open)}>
            <MenuTrigger>{children}</MenuTrigger>
            <MenuPopover style={{ width: '300px', minWidth: '300px' }}>
                <MenuList>
                    <div className="p-2">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <span className={styles.tableFilterHeader}>Set Deadline</span>
                        </div>

                        <div className="mb-3">
                            <label className="form-label small mb-0" style={{ fontSize: '10px' }}>
                                Deadline
                            </label>
                            <input
                                type="date"
                                className={'form-control form-control-sm ' + styles.filterSelect}
                                value={deadline || ''}
                                onChange={e => setDeadline(e.target.value)}
                            />
                        </div>

                        <div className="d-flex gap-2 justify-content-between">
                            <span className={styles.secondaryBtnText + ' ms-1'} onClick={handleSaveDeadline}>
                                Save deadline
                            </span>
                            <span className={styles.secondaryBtnText + ' ms-1'} onClick={handleClearDeadline}>
                                Clear
                            </span>
                        </div>
                    </div>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default DeadlinePickerMenu;
